import { ProfileCardBgDef } from "./profileCardBackgrounds"
import { ProfileNicknameColorDef } from "./profileNicknameColors"
import {
  areHarmoniesCompatible,
  CosmeticsHarmony,
  HARMONY_PALETTES,
  HarmonyPalette,
  pickDominantHarmony,
  resolveNickColorForHarmony,
} from "./profileCosmeticsHarmony"

export type HarmonizedCardLook = {
  dominant: CosmeticsHarmony
  palette: HarmonyPalette
  nickColor: string | null
  winrateColor: string | null
  nickRetinted: boolean
}

export function harmonizeCardLook(input: {
  bg: ProfileCardBgDef | null
  nick: ProfileNicknameColorDef | null
}): HarmonizedCardLook {
  const dominant = pickDominantHarmony(input.bg?.style.harmony, null)
  const palette = HARMONY_PALETTES[dominant]
  const nickRetinted = Boolean(
    input.nick && !areHarmoniesCompatible(input.nick.harmony, dominant)
  )
  const nickColor = resolveNickColorForHarmony(
    input.nick?.color,
    input.nick?.harmony,
    dominant
  )

  return {
    dominant,
    palette,
    nickColor,
    winrateColor: input.bg?.style.winrateColor ?? palette.winrateColor,
    nickRetinted,
  }
}
